import React from 'react';
import { useNavigate } from 'react-router-dom';

const IDCardButton = () => {
  const navigate = useNavigate();

  const handleViewIDCard = () => {
    navigate('/id-card');
  };

  return (
    <div className="flex justify-center">
      <button
        onClick={handleViewIDCard}
        className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors"
      >
        View My Digital ID Card
      </button>
    </div>
  );
};

export default IDCardButton;